import { render, staticRenderFns } from "./sertifikasi_kompetensi.vue?vue&type=template&id=6b2f4c32"
import script from "./sertifikasi_kompetensi.vue?vue&type=script&lang=js"
export * from "./sertifikasi_kompetensi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports